import { render, staticRenderFns } from "./ctrIndex.vue?vue&type=template&id=6c5e7050&scoped=true&"
import script from "./ctrIndex.vue?vue&type=script&lang=js&"
export * from "./ctrIndex.vue?vue&type=script&lang=js&"
import style0 from "./ctrIndex.vue?vue&type=style&index=0&id=6c5e7050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e7050",
  null
  
)

export default component.exports